import axiosClient from '../libs/axios';

// Proje finansal kayıtlarını getir
export const getProjectFinancials = async (data) => {
  const response = await axiosClient.get('/projects/financials/' + data.slug);
  return response.data;
};

// Yeni finansal kayıt ekle
export const addProjectFinancial = async (data) => {
  const response = await axiosClient.post('/projects/financials/add/' + data.slug, {
    type: data.type,
    category: data.category,
    description: data.description,
    amount: data.amount,
    date: data.date,
    notes: data.notes,
    payment_status: data.payment_status,
    payment_method: data.payment_method,
    invoice_number: data.invoice_number,
    due_date: data.due_date,
    currency: data.currency,
    exchange_rate: data.exchange_rate,
    tags: data.tags
  });
  return response.data;
};

// Finansal kaydı güncelle
export const updateProjectFinancial = async (data) => {
  const response = await axiosClient.post('/projects/financials/update/' + data.slug, {
    id: data.id,
    type: data.type,
    category: data.category,
    description: data.description,
    amount: data.amount,
    date: data.date,
    notes: data.notes,
    payment_status: data.payment_status,
    payment_method: data.payment_method,
    invoice_number: data.invoice_number,
    due_date: data.due_date,
    currency: data.currency,
    exchange_rate: data.exchange_rate,
    tags: data.tags
  });
  return response.data;
};

// Finansal kaydı sil
export const deleteProjectFinancial = async (data) => {
  const response = await axiosClient.post('/projects/financials/delete/' + data.slug, {
    id: data.id
  });
  return response.data;
};

// Finansal kayıtları filtrele
export const filterProjectFinancials = async (data) => {
  const response = await axiosClient.post('/projects/financials/filter/' + data.slug, {
    type: data.type,
    category: data.category,
    payment_status: data.payment_status,
    start_date: data.start_date,
    end_date: data.end_date,
    min_amount: data.min_amount,
    max_amount: data.max_amount,
    search: data.search,
    currency: data.currency,
    sort_by: data.sort_by,
    sort_order: data.sort_order
  });
  return response.data;
};

// Finansal özet/istatistikler
export const getProjectFinancialSummary = async (data) => {
  const response = await axiosClient.get('/projects/financials/summary/' + data.slug);
  return response.data;
};

// Kategoriye göre finansal analiz
export const getProjectFinancialsByCategory = async (data) => {
  const response = await axiosClient.get('/projects/financials/by-category/' + data.slug);
  return response.data;
};

// Periyoda göre finansal analiz
export const getProjectFinancialsByPeriod = async (data) => {
  const response = await axiosClient.get('/projects/financials/by-period/' + data.slug, {
    params: {
      period: data.period || 'monthly' // monthly veya yearly
    }
  });
  return response.data;
};

// CSV Export
export const exportProjectFinancialsCSV = async (data) => {
  const response = await axiosClient.get('/projects/financials/export/' + data.slug, {
    responseType: 'blob'
  });
  
  // Dosyayı indir
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `finansal-kayitlar-${data.slug}-${new Date().toISOString().split('T')[0]}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return response.data;
};

